import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from '../_services/environment.service';
import { MsalService } from "@azure/msal-angular";
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  fullUrl = '';
  cafamHomeURL = '';

  constructor(  private authService: AuthenticationService,
                private authB2c: MsalService,
                private envService: EnvironmentService,
                private router: Router,) { }

  ngOnInit() {
    //this.fullUrl = this.envService.cafamLoginURL + this.envService.appReturnURL;
    //this.cafamHomeURL = this.envService.cafamHomeURL;
    this.authService.logout();
    this.authB2c.logout();
    this.router.navigate(['/']);

  }

}
